import LightGallery from 'lightgallery/react';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import "./style.css"
import PdfFileCard from '.';

const PatientFilesGallery = ({ ImgsList, modalId }: { ImgsList: any[], modalId: any }) => {
    return (
        <div onClick={() => modalId.current.click()}>
            <LightGallery
                onInit={() => { }}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
            >
                {
                    <>
                        {ImgsList?.map((item, index) => (
                            <a key={index} href={`${window.API_URL}/${item?.fullPath}`}>
                              <PdfFileCard isImg file={item} />
                            </a>
                        ))}
                    </>
                }
            </LightGallery>
        </div>
    )
}

export default PatientFilesGallery